import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvoiceService } from './invoice.service';
import { TicketService } from '../tickets/ticket.service';

@Component({
  selector: 'convfact-invoiceverifactu',
  templateUrl: './invoice-dialog-verifactu.component.html',
  styleUrls: ['./invoice-dialog-verifactu.component.css'],
  standalone: false
})
export class InvoiceDialogVerifactuComponent implements OnInit {
  loading = true;
  loadError = false;
  qrBase64: string = null;
  events: { text: string, detail: string | null, expanded: boolean }[] = [];

  constructor(
    public dialogRef: MatDialogRef<InvoiceDialogVerifactuComponent>,
    public invoiceService: InvoiceService,
    public ticketService: TicketService,
    @Inject(MAT_DIALOG_DATA) public data: { uid: string; type: 'invoice' | 'ticket'; number?: string },
  ) { }

  ngOnInit(): void {
    const isTicket = this.data.type === 'ticket';
    const events = isTicket ? this.ticketService.getEvents(this.data.uid) : this.invoiceService.getEvents(this.data.uid);
    const qr = isTicket ? this.ticketService.getQR(this.data.uid) : this.invoiceService.getQR(this.data.uid);

    Promise.allSettled([events, qr]).then(([eventsResult, qrResult]) => {
      if (eventsResult.status === 'fulfilled' && eventsResult.value) {
        this.events = (eventsResult.value.events || []).map(item => this.formatEvent(item));
      }
      if (qrResult.status === 'fulfilled' && qrResult.value) {
        this.qrBase64 = qrResult.value.qrBase64 || null;
      }
      this.loadError = eventsResult.status === 'rejected' && qrResult.status === 'rejected';
      this.loading = false;
    });
  }

  private formatEvent(item: string): { text: string, detail: string | null, expanded: boolean } {
    const raw = String(item || '').trim();

    if (raw.indexOf('esquema XSD') !== -1) {
      return { text: 'El XML no pasó la validación de esquema de la AEAT', detail: raw, expanded: false };
    }

    if (raw.length > 160) {
      return { text: raw.substring(0, 160).trim() + '…', detail: raw, expanded: false };
    }

    return { text: raw, detail: null, expanded: false };
  }

  toggleDetail(event: { expanded: boolean }): void {
    event.expanded = !event.expanded;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  public trackByIndex(i: number) { return i; }
}
